/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import moment from "moment";
import TableCell from "../../../components/TableCell";

export const ROUTE_VERIFIED_COLUMNS = [
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber",
    Cell: ({ cell }) => <TableCell.Link value={cell.value} />
  },
  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To #",
    accessor: "BillToNumber",
    id: "BillToNumber",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Bill To Name",
    accessor: "BillToName",
    id: "BillToName",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Route",
    accessor: "RouteId",
    id: "RouteId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Route Description",
    accessor: "RouteDescription",
    id: "RouteDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Delivery Date",
    accessor: "ScheduledDeliveryDate",
    id: "ScheduledDeliveryDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  },
  {
    Header: "Verified By",
    accessor: "VerifiedByUserId",
    id: "VerifiedByUserId",
    Cell: ({ cell }) => (cell.value ? cell.value : "")
  }
];

export const BILLING_VERIFIED_COLUMNS = [
  {
    Header: "Order #",
    accessor: "OrderNumber",
    id: "OrderNumber"
  },

  {
    Header: "Customer #",
    accessor: "CustomerNo",
    id: "CustomerNo"
  },
  {
    Header: "Customer Name",
    accessor: "CustomerName",
    id: "CustomerName"
  },
  {
    Header: "Bill To #",
    accessor: "BillToNumber",
    id: "BillToNumber"
  },
  {
    Header: "Bill To Name",
    accessor: "BillToName",
    id: "BillToName"
  },
  {
    Header: "Route",
    accessor: "RouteId",
    id: "RouteId"
  },
  {
    Header: "Pickup Date",
    accessor: "PickupDate",
    id: "PickupDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Delivery Date",
    accessor: "RequestedDeliveryDate",
    id: "RequestedDeliveryDate",
    Cell: ({ cell }) =>
      cell.value ? moment(cell.value).format("MM/DD/YYYY") : null
  },
  {
    Header: "Status",
    accessor: "StatusIdDescription",
    id: "StatusIdDescription"
  }
];
